import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '@/configuration/setup/store';

interface AssetTreeState {
    assetIds: string[];
    accountIds: string[];
    workshopIds: string[];
    // True once the parent frontend has sent its first selection (empty or not).
    initialized: boolean;
}

const initialState: AssetTreeState = {
    assetIds: [],
    accountIds: [],
    workshopIds: [],
    initialized: false,
};

const assetTreeSlice = createSlice({
    name: 'assetTree',
    initialState,
    reducers: {
        assetTreeSelectionChanged: (state, action: PayloadAction<Partial<AssetTreeState>>) => {
            state.assetIds = action.payload.assetIds ?? [];
            state.accountIds = action.payload.accountIds ?? [];
            state.workshopIds = action.payload.workshopIds ?? [];
            state.initialized = true;
        },
    },
});

export const { assetTreeSelectionChanged } = assetTreeSlice.actions;

export const getAssetTreeAssetIds = (state: RootState) => state.assetTree.assetIds;
export const getAssetTreeAccountIds = (state: RootState) => state.assetTree.accountIds;
export const getAssetTreeWorkshopIds = (state: RootState) => state.assetTree.workshopIds;
export const getAssetTreeInitialized = (state: RootState) => state.assetTree.initialized;

export default assetTreeSlice.reducer;
